export default {
  variablesMapping: {
    fr: {
      authCustomer: {
        PRENOM: 'firstname',
        NOM: 'lastname',
      },
      authCustomerExtraData: {
        POURCENTAGE_PROGRESSION: 'completedPercentage',
      },
      training: {
        NOM_FORMATION: 'name',
      },
      trainingItem: {
        NOM_LECON: 'name',
      },
    },
    en: {
      authCustomer: {
        FIRSTNAME: 'firstname',
        LASTNAME: 'lastname',
      },
      authCustomerExtraData: {
        COMPLETED_PERCENTAGE: 'completedPercentage',
      },
      training: {
        TRAINING_NAME: 'name',
      },
      trainingItem: {
        LESSON_NAME: 'name',
      },
    },
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    store: {
      type: Object,
      required: true,
    },
    authCustomer: {
      type: Object,
      default: null,
    },
    authCustomerExtraData: {
      type: Object,
      default: null,
    },
    data: {
      type: Object,
      required: true,
    },
    training: {
      type: Object,
      required: true,
    },
    trainingItem: {
      type: Object,
      required: true,
    },
    trainingItems: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getFormattedText(text) {
      if (!text) return '';

      let processedText = text;
      const allMappings = this.$options.variablesMapping[this.$i18n.locale];

      for (const sourceName in allMappings) {
        const sourceObject = this[sourceName];
        const sourceMappings = allMappings[sourceName];

        if (sourceObject) {
          for (const placeholder in sourceMappings) {
            const propName = sourceMappings[placeholder];
            const value = sourceObject[propName];

            if (value !== undefined && value !== null) {
              const regex = new RegExp(`{{\\s*${placeholder}\\s*}}`, 'g');
              processedText = processedText.replace(regex, value);
            }
          }
        }
      }

      return processedText;
    },
  },
};
